<template>
  <Nav-bar :has_back="false" :has_right="false" title="用户中心"></Nav-bar>
     <div class="unpaid-lab" v-if="isHasUnpaid" @click="toOrderList">
      <img src="../../images/unpaid_tip.png" />
      <span> 当前有未支付订单,请尽快支付!</span>
      <img src="../../images/disclosure.png" class="right-icon" />
    </div>
  <div class="container">
    <img src="@/images/personal_head_background.png" class="bg-icon" />
    <div class="user-info">
      <div class="row" v-if="state.userInfo">
        <img :src="state.userImg" class="user-pic" />
        <div class="m-l-10" @click="toWechatSignIn">
          <span class="t-f18-c1a font-bold">{{
            state.userInfo.nick_name
          }}</span>
          <div class="t-f12-c66">{{ state.userInfo.mobile }}</div>
        </div>
      </div>

      <div class="row" v-else>
        <img src="@/images/login_page_user_not_login.png" class="user-pic" />
        <div class="m-l-10 column" @click="toWechatSignIn">
          <span class="t-f18-c1a font-bold">注册登录</span>
          <div class="t-f12-c66">当前尚未登录，请先登录或注册</div>
        </div>
      </div>
      <!-- 余额 优惠券栏-->
      <div class="row m-t-15 row">
        <div class="column-item">
          <span :class="state.userInfo != null ? 't-f16-c1a' : 't-f16-c99'">{{
            state.userInfo == null ? "--" : state.userInfo.balance
          }}</span>
          <span class="t-f12-c99">余额</span>
        </div>
        <div class="line" />
        <div class="column-item" @click="toText">
          <span :class="state.userInfo != null ? 't-f16-c1a' : 't-f16-c99'">{{
            state.userInfo == null ? "--" : state.userInfo.level_points
          }}</span>
          <span class="t-f12-c99">积分</span>
        </div>
        <div class="line" />
        <div class="column-item">
          <span :class="state.userInfo != null ? 't-f16-c1a' : 't-f16-c99'">{{
            state.userInfo == null ? "--" : state.userInfo.coupon_count
          }}</span>
          <span class="t-f12-c99">优惠券</span>
        </div>
      </div>
      <!-- 快捷栏-->
      <div class="fast-column">
        <div class="fast-item" @click="toWallet">
          <img src="@/images/my_function_wallet.png" class="fast-icon" />
          <span class="t-f12-c66 m-t-5">钱包</span>
        </div>
        <div class="fast-item" @click="toReceipt">
          <img src="@/images/my_function_receipt.png" class="fast-icon" />
          <span class="t-f12-c66 m-t-5">开票</span>
        </div>
        <div class="fast-item" @click="loginOut" v-if="isHasToken">
          <img src="@/images/my_function_my_favourite.png" class="fast-icon" />
          <span class="t-f12-c66 m-t-5">退出登录</span>
        </div>
        <div class="fast-item" @click="toOrderList">
          <img
            src="@/images/my_function_charging_record.png"
            class="fast-icon"
          />
          <span class="t-f12-c66 m-t-5">充电记录</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import { useRouter } from "vue-router";
import tokenHelper from "@/helpers/token_helper";
import request from "@/api/request.js";
import { reactive, ref } from "vue";
import { Toast } from "vant";
let isHasUnpaid = ref(false);
let router;
let state;

let isHasToken;
export default {
  components: {
    NavBar: NavBar,
  },
  setup() {
    router = useRouter();
    state = reactive({
      userInfo: null, //基本信息
      userImg: "",
    });
    isHasToken = ref(false);
  
    return {
      toWechatSignIn,
      toOrderList,
      state,
      loginOut,
      isHasToken,
      toWallet,
      toText,
      isHasUnpaid,
      toReceipt,
    };
  },
  created() {
    if (tokenHelper.readAccessToken() != null) {
      isHasToken.value = true;
      //查询个人中心数据
      this.apiUserMeans();
      this.checkUnpaidOrder();
    }
  },
  methods: {
    apiUserMeans() {
      return new Promise(() => {
        request.getUserInfo().then((res) => {
          state.userInfo = res.data;
          state.userImg = window.location.origin.replace("-webapp", "") + res.data.avatar.small.url;
          console.log(state.userImg)
        });
      });
    },
    checkUnpaidOrder() {
      let param = {};
      param["status"] = "unpaid";
      request.getOrderList(param).then((res) => {
        isHasUnpaid.value = res.data.results.length != 0;
      });
    },
  },
};

//去我的钱包
function toWallet() {
  router.push("/user/wallet");
}
function toText(){
   router.push("");
}
//发票
function toReceipt() {
  router.push("/user/receipt/container");
}
function loginOut() {
  localStorage.clear();
  state.userInfo = null;
  isHasToken.value = false;
  isHasUnpaid.value = false;
  Toast("已退出账号");
}
//跳转充电订单
function toOrderList() {
  router.push("/user/orders_list");
}
//去登录页面
function toWechatSignIn() {
  if (!tokenHelper.readAccessToken()) {
    router.push("/auths/WechatAuth");
  }
}
</script>

<style scoped>
.container {
  position: relative;
}
.bg-icon {
  width: 100%;
}
.fast-icon {
  height: 22px;
  width: 22px;
  flex-shrink: 0;
  margin: 0 auto;
}
.fast-column {
  border-radius: 5px;
  background: #fff;
  padding: 15px 0px;
  margin-top: 15px;
  display: flex;
}
.fast-item {
  display: flex;
  flex: 1;
  flex-direction: column;
  text-align: center;
}
.l-i {
  text-align: left;
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-left: 30px;
}
.user-info {
  position: absolute;
  top: 85px;
  left: 15px;
  right: 15px;
  flex-direction: column;
}
.row {
  display: flex;
  flex-direction: row;
}
.line {
  height: 16px;
  border-right: 1px solid #e0e0e0;
}
.user-pic {
  width: 45px;
  height: 45px;
  border-radius: 50%;
}
.column {
  display: flex;
  flex-direction: column;
}
.column-item {
  flex: 1;
  display: flex;
  text-align: center;
  flex-direction: column;
}
.unpaid-lab {
  z-index: 999;
  position: absolute;
  top: 35px;
  left: 0;
  right: 0;
  padding: 10px 15px;
  align-items: center;
  justify-items: center;
  background: #fff6f6;
}
.unpaid-lab img {
  width: 15px;
  height: 15px;
  margin: auto 0;
  vertical-align: middle;
}

.unpaid-lab span {
  color: #fb0006;
  font-size: 14px;
}
.right-icon {
  width: 22px !important;
  height: 22px !important;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 15px;
}
</style>